import styled, { css } from 'styled-components';

interface BtnProps {
  text: string;
  colorType: string;
  width: string;
  height: string;
  fontSize: string;
  onClick: () => void;
}

const Btn = ({
  text,
  colorType,
  width,
  height,
  fontSize,
  onClick,
}: BtnProps) => {
  return (
    <>
      <Wrap
        $colorType={colorType}
        $width={width}
        $height={height}
        $fontSize={fontSize}
        onClick={onClick}
      >
        {text}
      </Wrap>
    </>
  );
};

export default Btn;

const Wrap = styled.button<{
  $colorType: string;
  $width: string;
  $height: string;
  $fontSize: string;
}>`
  width: ${({ $width }) => $width};
  min-width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  border-radius: 4px;
  border: none;
  font-size: ${({ $fontSize }) => $fontSize};
  ${({ $colorType }) => {
    if ($colorType === 'type1') {
      return css`
        background-color: ${({ theme }) => theme.mainColor1};
        color: #fff;
      `;
    }
    if ($colorType === 'type2') {
      return css`
        background-color: #eee;
        color: #666;
      `;
    }
  }}
`;
